import React from "react"
import NoBodyStyles from "./body.less"
import {connect} from "react-redux"
import errorImg from "../../static/pic/error.png"
import noTemplateImg from "../../static/pic/noTemplate.png"
import tubiao from "../../static/pic/图表.svg"
import loadingImg from "../../static/pic/页面加载.gif"

// eslint-disable-next-line react/prefer-stateless-function
export class NoDataBody extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }

    getPicAndTips = () => {
        switch (this.props.status) {
            case "noTemplate":
                return {
                    pic: noTemplateImg,
                    tip: "未能识别到任何结果。",
                }
            case "error":
                return {
                    pic: errorImg,
                    tip: "识别异常，请检查图片类型是否匹配或图片是否清晰后重新上传。",
                }
            case "loading":
                return {
                    pic: loadingImg,
                    tip: "识别中......",
                }
            default:
                return {
                    pic: tubiao,
                    tip: "正在上传并分类",
                }
        }
    }

    render() {
        return (
            <div className={NoBodyStyles.startAndErrorPic}>
                <div className={NoBodyStyles.showPicImgBox}>
                    <img className={NoBodyStyles.showPic} src={this.getPicAndTips().pic} />
                </div>
                <p className={NoBodyStyles.showTip}>{this.getPicAndTips().tip}</p>
            </div>
        )
    }
}
export default connect((state: any) => {
    return {
        templateName: state.templateName,
        errorMessage: state.errorMessage,
    }
})(NoDataBody)
